import { t as trapFocus, r as removeTrapFocus } from './index-BIftRuJC.js';

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawer = this;
    this.body = document.querySelector('body');
    this.activeClass = 'cart-drawer-is-open';
    this.cartIconBubble = document.querySelector('cart-icon-bubble');

    this.closeButtons = this.querySelectorAll('[data-cart-button-close]');
    this.closeButtons.forEach((btn) => btn.addEventListener('click', this.close.bind(this)));

    this.onBodyClick = this.handleBodyClick.bind(this);

    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
  }

  open() {
    this.body.classList.add(this.activeClass);
    this.cartIconBubble.toggleButton.setAttribute('aria-expanded', true);

    this.drawer.focus();
    trapFocus({ container: this.drawer });
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.body.classList.remove(this.activeClass);
    this.cartIconBubble.toggleButton.setAttribute('aria-expanded', false);

    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus();
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      if (section?.selector) {
        const selector = document.querySelector(section.selector);

        if (!selector) return;
        const newHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );

        if (newHTML) {
          selector.innerHTML = newHTML;
        }
      }
    });

    this.toggleEmptyCart();

    // Re-bind the close drawer buttons
    this.querySelectorAll('[data-cart-button-close]').forEach((btn) =>
      btn.addEventListener('click', this.close.bind(this))
    );
  }

  /**
   * Toggle the empty state of the cart
   */
  toggleEmptyCart() {
    this.currentItemCount = this.querySelectorAll('[data-line-item]').length;
    this.classList.toggle('cart-is-empty', this.currentItemCount === 0);
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-header',
        section: document.getElementById('main-cart-header').dataset.id,
        selector: '.js-cart-header-contents',
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-cart-item-contents',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-cart-footer-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML;
  }

  handleBodyClick(event) {
    const target = event.target;
    if (target !== this.drawer && !target.closest('cart-drawer')) {
      this.close();
    }
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}
